import { useCallback, useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { hideBackButton, setBackButton } from '../lib/tma';

/**
 * Telegram's own back button, leading to an explicit parent (spec 5.6) — never
 * history.back(): a screen opened from a bot notification has no history.
 * `guard` returning false keeps the person on the screen (e.g. unsaved edits).
 * Without `to` the button is hidden. Returns the same handler for an on-screen back.
 */
export function useTelegramBack(to: string | undefined, guard?: () => boolean): () => void {
  const navigate = useNavigate();
  const guardRef = useRef(guard);
  guardRef.current = guard;

  const back = useCallback(() => {
    if (to === undefined) return;
    if (guardRef.current?.() === false) return;
    navigate(to);
  }, [navigate, to]);

  useEffect(() => {
    if (to === undefined) {
      hideBackButton();
      return;
    }
    return setBackButton(back);
  }, [to, back]);

  return back;
}
